import Axios from "../utils/request";

// 登录页   发送验证码
export const code = data =>
    Axios({
        url: "/register/app/sendSms",
        method: "post",
        data
    });

// 登录页   登录系统  验证码登录
export const login = data =>
    Axios({
        url: "/login/v2/smsLogin",
        method: "post",
        data
    });

// 登录页   登录系统  密码登录
export const passwordLogin = data =>
    Axios({
        url: "/login/userLogin",
        method: "post",
        data
    });

// 登录页   登录系统  设置密码
export const insertLoginPWD = data =>
    Axios({
        url: "/login/insertLoginPWD",
        method: "post",
        data
    });

// 重置密码页  重置密码
export const reSetPassword = data =>
    Axios({
        url: "/findPwd/restMemPwd",
        method: "post",
        data
    });

// 登录页   退出登录
export const logout = data =>
    Axios({
        url: "/login/loginOut",
        method: "post",
        data
    });

    
// 配置信息
export const config = data =>
Axios({
    url: "/user/config",
    method: "post",
    data
});

// 安装数统计
export const downoknotify = data =>
Axios({
    url: "/comm/downoknotify",
    method: "post",
    data
});

// 安装数统计
export const device = data =>
Axios({
    url: "/fetch/user/device",
    method: "post",
    data
});
// 安装数统计
export const position = data =>
Axios({
    url: "/fetch/user/position",
    method: "post",
    data
});